module.exports = __webpack_public_path__ + "static/homepage-link-below-header-cace5cc88f978d4396d6d692932da3c0.png";